import React from "react";
import PreStartQuestionPreview from "../PreStartQuestionPreview";
import { getReadinessChecklist } from "../../../JobShiftReadiness/sections/readinessQuestionsFormUtils";
import styles from "../../../JobShiftPreStart/JobShiftPreStartView.module.css";

export default function EmergencyReadinessQuestionsPreview({ readiness }) {
  const checklist = getReadinessChecklist(readiness);
  const questions = Array.isArray(checklist.questions) ? checklist.questions : [];
  const headingContents = checklist.heading_contents && typeof checklist.heading_contents === "object"
    ? checklist.heading_contents
    : {};
  const heading = headingContents.rescue_readiness_checklist_heading || "";

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview} ${styles.readinessSectionNum}`}>2</span>
        Rescue Readiness Questions
      </div>
      <div className={styles.PreviewSectionBody}>
        {heading ? (
          <div className={`${styles.PreviewRichText} preview-swms-v3-authorization-rich-text`} dangerouslySetInnerHTML={{ __html: heading }} />
        ) : null}
        <table className={styles.PreviewTable}>
          <tbody>
            {questions.map((question, index) => (
              <PreStartQuestionPreview
                key={question.id || `readiness-question-${index}`}
                number={index + 1}
                question={question}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
